function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.33341 12.3333C9.94155 13.1429 10.9095 13.6666 12.0001 13.6666C13.841 13.6666 15.3334 12.1742 15.3334 10.3333C15.3334 9.58105 15.075 8.89478 14.6547 8.33691L14.6667 8.33331L8.00008 0.333313L1.33341 8.33331L1.34541 8.33691C0.925148 8.89478 0.666748 9.58105 0.666748 10.3333C0.666748 12.1742 2.15915 13.6666 4.00008 13.6666C5.09061 13.6666 6.05861 13.1429 6.66675 12.3333C6.79968 12.1562 7.05368 11.818 7.33341 11.4449V14.3333C7.33341 16.3333 4.00008 16.3333 4.00008 16.3333C3.63195 16.3333 3.33341 16.6317 3.33341 17C3.33341 17.3681 3.63195 17.6666 4.00008 17.6666H7.33341H8.66675H12.0001C12.3682 17.6666 12.6667 17.3681 12.6667 17C12.6667 16.6317 12.3682 16.3333 12.0001 16.3333C12.0001 16.3333 8.66675 16.3333 8.66675 14.3333V11.4449C8.94648 11.818 9.20048 12.1562 9.33341 12.3333Z",
  fill: "#7C8288"
});

const SvgBlackjack = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 18,
  viewBox: "0 0 16 18",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBlackjack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/blackjack.ad726001.svg";
export { ForwardRef as ReactComponent };